import { render, staticRenderFns } from "./PrintDeliveryNotes.vue?vue&type=template&id=c70361d8&scoped=true&"
import script from "./PrintDeliveryNotes.vue?vue&type=script&lang=js&"
export * from "./PrintDeliveryNotes.vue?vue&type=script&lang=js&"
import style0 from "./PrintDeliveryNotes.vue?vue&type=style&index=0&id=c70361d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70361d8",
  null
  
)

export default component.exports